<template>
    <component :is="component" @voteEdit="voteEdit" @setComponent="setComponent" :vote_id="vote_id" @loading="setLoading($event)"></component>
</template>

<script>
import VoteEdit from './VoteEdit.vue';
import VoteList from './VoteList.vue';
export default {
  name: "VoteSystyem",
  components: {
    VoteEdit,
    VoteList
  },
  data() {
    return {
      component: 'VoteList',
      vote_id: null,
      breadcrumb: {
        show: false,
        name: ''
      }
    };
  },
  methods: {
    setComponent(payload) {
      this.component = payload
    },
    voteEdit(item) {
      this.component = 'VoteEdit';
      this.vote_id = item.id;
      this.breadcrumb.name = item.description;
    },
    setLoading(value) {
      this.$emit('loading', value)
    }
  },
  watch: {
    component(value) {
      this.breadcrumb.show = (value == 'VoteEdit') ? true : false;
      this.$emit('setBreadcrumb', this.breadcrumb);
    }
  },
  beforeDestroy() {
    this.breadcrumb.show = false;
    this.$emit('setBreadcrumb', this.breadcrumb);
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/VoteSystem.vue